import TrackWrapper from '@/common/TrackWrapper';
import {
  useDeviceType,
  useIsMobile,
  useScreenSize
} from '~/context/common/DeviceContext';
import { SearchBar } from '../../SearchBar';
import { HeroImage, HeroWrapper, PageTitle } from '../Hero.styles';

export default function PromoHero() {
  const isMobile = useIsMobile();
  const isTablet = useDeviceType().isTablet;
  const screenWidth = useScreenSize().width;

  const assetsUrl = process.env.CVNA_APP_CDN_ASSETS_PATH;

  const heroImg = {
    xlarge: `${assetsUrl}/images/home_heroes/kb_ds_010725.jpg`,
    large: `${assetsUrl}/images/home_heroes/kb_ds_121624.jpg`,
    medium: `${assetsUrl}/images/home_heroes/kb_ds_121624.jpg?trim=0,540,0,0`,
    small: `${assetsUrl}/images/home_heroes/kb_ds_mobile_121624v2.jpg`
  };

  const backgroundImage = isMobile
    ? `url(${heroImg.small})`
    : isTablet
    ? `url(${heroImg.medium})`
    : screenWidth <= 1440
    ? `url(${heroImg.large})`
    : `url(${heroImg.xlarge})`;

  return (
    <div className="relative z-[2]">
      <HeroWrapper>
        <HeroImage id="redesign-hero-image" style={{ backgroundImage }} />
        <section className="absolute top-0 flex h-full w-full flex-col items-center justify-center px-2xl sm:px-0">
          <PageTitle data-qa="hero-title">
            right car.
            <br className="sm:hidden" /> right price.
          </PageTitle>
          <span className="mb-2xl hidden text-xl font-semibold leading-6 text-white sm:block">
            Financing made easy.
          </span>
          <TrackWrapper
            event={{ eventName: 'search_bar_viewed' }}
            className="relative w-full sm:max-w-[524px] md:min-w-[524px] md:max-w-[680px]"
          >
            <div className="relative h-56">
              <SearchBar />
            </div>
          </TrackWrapper>
        </section>
      </HeroWrapper>
    </div>
  );
}
